import React from "react";
import { useChat } from "../../../../../../../../context/ChatContext/ChatContext";
import { Empty } from "antd";
import ChatRoomListItem from "../ChatRoomListItem";
import { Message } from "../../../../../../../BP2Components";
import { useIntl } from "react-intl";

interface ChatBotRoomsListProps {}

const ChatBotRoomsList: React.FC<ChatBotRoomsListProps> = ({}) => {
   const chatData = useChat();

   const intl = useIntl();

   if (!chatData?.chatData?.users)
      return <Empty description={intl.formatMessage({ id: "chat.no-items-found" })} />;

   let botUsers = chatData?.chatData?.users?.filter((user) => user?.userType === "bot");

   if (botUsers?.length === 0) return <Empty description="boty nie istnieją" />;

   return (
      <>
         {botUsers?.map((user) => (
            <ChatRoomListItem
               listType="Contact"
               user={user}
               onClick={() => {
                  Message.warning("Funkcja niedostępna");
               }}
            />
         ))}
      </>
   );
};

export default ChatBotRoomsList;
